import * as React from 'react';
import clsx from 'clsx';
import { useFocus, useCombinedRefs } from '@ovpn-ui/utils';
import Box from '../../../Box';
import Tooltip from '../../../Tooltip';
import withProps from '../../utils/withProps';
import * as Styled from './InputContainer.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultIconProps = {
  size: 'md'
};
function InputContainer(props, ref) {
  const {
    children: _children,
    inputRef,
    // state
    disabled = false,
    error = false,
    autoFocus,
    // appearance
    className,
    iconLeft,
    iconRight,
    tooltip,
    prefix,
    suffix,
    // box default props
    flex = true,
    inline,
    center = true,
    m,
    mb,
    mt,
    ml,
    mr,
    p,
    pb,
    pt,
    pl,
    pr,
    ...htmlAttributes
  } = props;
  const innerRef = React.useRef(null);
  const focused = useFocus(innerRef, autoFocus);
  const combinedRef = useCombinedRefs(inputRef, innerRef);
  const withTooltip = () => {
    if (!!tooltip && !!iconRight) {
      return /*#__PURE__*/_jsx(Tooltip, {
        trigger: /*#__PURE__*/_jsx(Box, {
          className: "ovpn-input-trailing-icon",
          children: /*#__PURE__*/React.cloneElement(iconRight, {
            ...defaultIconProps,
            ...iconRight.props
          })
        }),
        children: tooltip
      });
    }
    if (iconRight) {
      return /*#__PURE__*/_jsx(Box, {
        className: "ovpn-input-trailing-icon",
        children: /*#__PURE__*/React.cloneElement(iconRight, {
          ...defaultIconProps,
          ...iconRight.props
        })
      });
    }
    return ``;
  };
  const children = React.useMemo(() => withProps(_children, {
    className: 'ovpn-input',
    ref: combinedRef,
    type: 'text',
    autoFocus,
    disabled,
    ...htmlAttributes
  }, (ownProps, customProps) => ({
    ...ownProps,
    ...customProps
  })), [htmlAttributes, disabled, combinedRef, _children, autoFocus]);
  const boxProps = {
    flex,
    inline,
    center,
    m,
    mb,
    mt,
    ml,
    mr,
    p,
    pb,
    pt,
    pl,
    pr
  };
  return /*#__PURE__*/_jsxs(Styled.Container, {
    className: clsx('ovpn-input-container', className),
    $disabled: disabled,
    $focused: focused,
    $error: error,
    ref: ref,
    onClick: e => {
      if (e.target !== innerRef.current) {
        e.stopPropagation();
      }
    },
    ...boxProps,
    children: [iconLeft && /*#__PURE__*/_jsx(Box, {
      className: "ovpn-input-leading-icon",
      children: /*#__PURE__*/React.cloneElement(iconLeft, {
        ...defaultIconProps,
        ...iconLeft.props
      })
    }), prefix && /*#__PURE__*/_jsx(Styled.Prefix, {
      className: "ovpn-input-prefix",
      children: prefix
    }), children, suffix && /*#__PURE__*/_jsx(Styled.Suffix, {
      className: "ovpn-input-suffix",
      children: suffix
    }), withTooltip()]
  });
}
export default /*#__PURE__*/React.forwardRef(InputContainer);